import styled from 'styled-components';
import CardBackground from "../../../assets/images/card_background.png"

export const StyledCardContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: calc(100% / 3 - 40px / 3);
    height: 300px;
    border-radius: 1.5rem;
    padding: 25px;
    justify-content: end;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    background-color: white;

    &.list {
        height: fit-content;
    }

    @media (max-width: 1100px) {
        width: 48%;
    }

    @media (max-width: 600px) {
        width: 100%;
        padding: 15px;
    }
`

export const StyledCardImage = styled.img`
    position: absolute;
    top: 0;
    width: auto;
    height: inherit;
    left: 50%;
    transform: translate(-50%, 0);
`

export const StyledEditImage = styled.img`
    position: absolute;
    top: 0;
    width: auto;
    height: auto;
    right: 60px;
    top: 10px;
    cursor: pointer;
    background-color: rgb(68, 164, 63);
    padding: 10px;
    border-radius: 100%;
    overflow: visible;
    z-index: 2;
`

export const StyledRemoveImage = styled.img`
    position: absolute;
    top: 0;
    width: auto;
    height: auto;
    right: 10px;
    top: 10px;
    cursor: pointer;
    background-color: rgb(68, 164, 63);
    padding: 10px;
    border-radius: 100%;
    overflow: visible;
    z-index: 2;
`

export const StyledCloseImage = styled.img`
    position: absolute;
    top: 0;
    width: auto;
    height: auto;
    right: 110px;
    top: 10px;
    cursor: pointer;
    background-color: rgb(68, 164, 63);
    padding: 10px;
    border-radius: 100%;
    overflow: visible;
    z-index: 2;
`

export const StyledRibbon = styled.span`
    color: #EEE;
    display: block;
    font-size: 11px;
    right: -48px;
    width: 40px;
    background-color: rgb(185 64 64);
    display: block;
    font-weight: 500;
    height: 48px;
    line-height: 72px;
    position: absolute;
    text-align: center;
    text-transform: uppercase;
    top: -8px;
    transform: rotate(45deg);
    vertical-align: bottom;
    width: 120px;
`

export const StyledCardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    border-radius: 1.5rem;
    background-color: #1E3815;
    padding: 1rem;
    box-sizing: border-box;
    gap: 1rem;
    z-index: 1;
`

export const StyledCardInfoColumn = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    border-radius: 1.5rem;
    align-items: center;
    justify-content: space-between;
`

export const StyledPlayerNumber = styled.span`
    display: flex;
    background-color: #1A1C21;
    border-radius: 100%;
    width: 30px;
    height: 30px;
    color: white;
    font-size: 12px;
    align-items: center;
    justify-content: center;
    position: absolute;
    border: 2px solid #1A1C21;
    right: 0;
`

export const StyledPlayerImage = styled.img`
    display: flex;
    background-color: #1A1C21;
    border-radius: 100%;
    width: 30px;
    height: 30px;
    color: white;
    font-size: 12px;
    align-items: center;
    justify-content: center;
    position: absolute;
    border: 2px solid #1A1C21;
`

export const StyledButtonWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 0.5rem;

    @media (max-width: 1380px) {
        flex-direction: column;
    }

    @media (max-width: 1100px) {
        flex-direction: row;
    }

    @media (max-width: 768px) {
        flex-direction: column;
    }

    @media (max-width: 600px) {
        flex-direction: row;
    }
`